import metadata from './metadata'
import blogPost from './blogPost'
import pageData from './pageData'
import { imageAsset, videoAsset } from '@/data/sanity/fragments'
import link from './link'

/* eslint-disable */
export const pageMetadataFields = `
  _type,
  _createdAt,
  _updatedAt,
  title,
  slug,
  isEnabled,
  metadata {
    ${metadata.fields}
  },
  _type == "page" => {
    ${pageData.fields}
  },
  _type == "blogPost" => {
    ${blogPost.fields}
  },
  _type == "pdfPost" => {
    pdfData {
      ${videoAsset.fragment('file')},
      fileName
    }
  },
  "globalMetaData": {
    ...(*[_type == "siteSettingsMetadata"] {
      _type,
      ${metadata.fields}
    }[0])
  }
`

export const pageSitemapFields = `
  _type,
  _updatedAt,
  slug,
  isEnabled,
  metadata {
    ${metadata.fields}
  }
`

export const richTextFields = `
  _key,
  _type,
  children[] {
    ...,
    _type == "link" => {
      ${link.fields}
    },
  },
  style,
  listItem,
  level,
  markDefs[]{
    ...,
    _type == "link" => {
      ${link.fields}
    },
  },
`

export const imageOrVideoFields = `
  type,
  ${imageAsset.fragment('image')},
  ${videoAsset.fragment('videoLoopDesktop')},
  ${videoAsset.fragment('videoLoopMobile')},
`

/* eslint-enable */
